<template>
  <div v-if="camera.version >= 2 && camera.version <= 4 && camera.snapshot_suspended_at" class="field">
    <label class="label">Snapshot collection</label>
    <span class="tag is-warning">
      Paused
    </span>
    <span class="ml-2">{{ suspensionDate }} UTC</span>
    <button v-if="!camera.is_deleted && camera.snapshot_suspended_at" type="button" class="button is-small is-link ml-2" :class="{ 'is-loading': saving }" :disabled="saving" @click="resume">
      Resume snapshot collection
    </button>
    <p v-if="error" class="has-text-danger" role="alert">{{ error }}</p>
  </div>
</template>

<script>
import { formatDate } from "@/utils/date_converter";
export default {
  name: "CameraSnapshotStatus",
  props: { camera: { type: Object, required: true } },
  data() { return { saving: false, error: "" }; },
  computed: {
    suspensionDate() { return formatDate(this.camera.snapshot_suspended_at, { showRelative: false, timeZone: "UTC" }); },
  },
  methods: {
    async resume() {
      if (!this.camera.snapshot_suspended_at || this.saving) return;
      const message = "Restart snapshot attempts with a fresh 3-day retry period?";
      if (!window.confirm(message)) return;
      this.saving = true; this.error = "";
      try {
        await this.$store.dispatch("resumeCameraSnapshots", { cameraId: this.camera.id });
      } catch { this.error = "Could not change snapshot status. Refresh and try again."; }
      finally { this.saving = false; }
    },
  },
};
</script>
